import { useSelector } from 'react-redux';
import { getCurrentTote } from './utils/scanningUtils';

const useToteStatus = () => {
  const {activeCart, nextPickItem, toteAssignments, previousNextPickItems, pickComplete,activeTote} = useSelector(state => ({
    toteAssignments: state.scanToCart.toteAssignments,
    nextPickItem: state.scanToCart.nextPickItem,
    activeCart: state.scanToCart.activeCart,
    previousNextPickItems: state.scanToCart.previousNextPickItems,
    pickComplete: state.scanToCartScanning.cartScanComplete,
    activeTote: state.scanToCartScanning.activeTote
  }));

  const getCurrentToteId = () => {
    const currentTote = getCurrentTote(previousNextPickItems, toteAssignments, nextPickItem);
    return pickComplete ? null : currentTote?.tote_id || null;
  };

  const currentToteId = getCurrentToteId();

  const getToteItemPieces = (toteId) => {
    if (!toteAssignments || !Array.isArray(toteAssignments)) return [];
    
    const toteAssignmentsForTote = toteAssignments.filter(assignment => assignment.tote_id === toteId);
    const allPieces = [];
    
    toteAssignmentsForTote.forEach(assignment => {
      if (assignment.item_pieces && Array.isArray(assignment.item_pieces)) {
        allPieces.push(...assignment.item_pieces);
      }
    });
    
    return allPieces;
  };

  const findNextOrderIdForPicking = toteAssignments => {
    const sortedTotes = [...toteAssignments].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    for (const tote of sortedTotes) {
      if (tote.isPrinted && getToteItemPieces(tote.tote_id).length > 0) {
        return tote.order_id;
      }
    }
    return null;
  };

  const getToteAssignments = toteId => {
    if (!toteAssignments || !Array.isArray(toteAssignments)) return [];
    return toteAssignments.filter(assignment => assignment.tote_id === toteId);
  };

  const getToteStatus = tote => {
    const itemPieces = getToteItemPieces(tote.tote_id);

    if (itemPieces.length === 0) {
      const liveAssignments = getToteAssignments(tote.tote_id);
      const assignments = liveAssignments.length > 0 ? liveAssignments : tote.assign_order_to_totes || [];
      if (assignments.length === 0) return 'unused';
    }

    if (tote.tote_id === currentToteId) return 'current';

    if (itemPieces.length === 0) return 'unused';

    const completedPieces = itemPieces.filter(piece => piece.status === 'picked_and_placed').length;
    const totalPieces = itemPieces.length;

    if (completedPieces === totalPieces) return 'complete';
    if (completedPieces > 0) return 'partial';
    return 'empty';
  };

  const calculateToteHeight = (itemPieces) => {
    if (itemPieces.length === 0) return 45;
    
    const circlesPerRow = 5;
    const numberOfRows = Math.ceil(itemPieces.length / circlesPerRow);
    const circleRowHeight = 16;
    const baseHeight = 45;
    
    return baseHeight + (numberOfRows * circleRowHeight);
  };

  const nextPickOrderId = activeCart.isPicked ? findNextOrderIdForPicking(toteAssignments) : null;

  return {
    activeCart,
    currentToteId,
    nextPickOrderId,
    activeTote,
    getToteItemPieces,
    getToteStatus,
    calculateToteHeight,
  };
};

export default useToteStatus;
